export default {
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Add to conference call?',
  mergeToConference: 'Merge',
  conferenceCall: 'Conference Call',
} as const;
